<template>
    <MuiWrapperWithShapes
        class="mui-c-video-wrapper-with-shapes"
        :enable-full-screen="props.enableFullScreen"
        :enable-scale-on-hover="props.enableFullScreen"
        :theme="props.theme"
    >
        <slot />
        <template #fullscreen>
            <slot name="fullscreen" />
        </template>
    </MuiWrapperWithShapes>
</template>

<script setup lang="ts">
    import MuiWrapperWithShapes from './WrapperWithShapes.vue';
    import type {MuiTheme} from '../../types/theme';

    const props = defineProps<{
        enableFullScreen?: boolean;
        theme?: MuiTheme;
    }>();
</script>
<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .mui-c-video-wrapper-with-shapes {
        .mui-c-wrapper-with-shapes__content {
            .video-player {
                margin: 0 auto;
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
                display: block;

                @include mq.screen_md(min) {
                    aspect-ratio: 1 / 1;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
